import { HomeContainer } from "../home/Home.container";
import { PageContainer } from "../page/Page.container";
import { NewsContainer } from "../news/News.container";
export const AppRoutes = {
    "/": HomeContainer,
    "/:slug": PageContainer,
    "/noticia/:slug": NewsContainer,
};
